var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabela-padrao-prime-vue',{staticClass:"my-4",attrs:{"colunas":_vm.tabela.colunas,"dados":_vm.tabela.dados,"mostrar-acoes":false,"sem-paginacao":true,"mostra-header":false,"mostrar-seletor":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }